import { dataService } from '../../data';

import { DataObject, ObjectOptions, RelatedObject } from '../base';
import { CreateObject } from '../item';

/****************************/
/* SCHEMA DEFINITION        */
/****************************/

import { TicketChangeType } from '../types';
import { AccountInvoiceType } from '../types';

import { TicketChange } from './ticketchange';
import { AccountInvoice } from './accountinvoice';

const _schema = {
    name: 'TICKETSII',
    fields: [
        { name: 'tckchg', alias: 'change', type: 'objid' },
        { name: 'invceac', alias: 'invoice', type: 'objid' },
        { name: 'region', type: 'string' },
        { name: 'error', type: 'string' },
        { name: 'sent', type: 'date' },
        { name: 'valid', type: 'string' },
    ],
    relate: [
        { direction: '>', target: 'TICKETCHANGE', by: 'change', name: 'change', reason: 'change', child: false, class: TicketChangeType },
        { direction: '>', target: 'ACCOUNTINVOICE', by: 'invceac', name: 'invoice', reason: 'invoice', child: false, class: AccountInvoiceType },
    ],
} as const;

const _TicketsiiClass = CreateObject(_schema);
if (!_TicketsiiClass) {
    throw new Error("Failed to create BaseClass for '" + _schema.name + "'");
}

/****************************/
/* CLASS DECLARATION        */
/****************************/

export class Ticketsii extends _TicketsiiClass {
    constructor(objid: string | null, data: dataService, objoptions: ObjectOptions | null = null){
        super(_schema, objid, data, objoptions || {});
    }

    Copy(store: Array<DataObject> = []): Ticketsii {
        return this._Copy(store) as Ticketsii;
    }

    /** Changelog rows lack parent fiscal lists; register on link (see TicketProduct). */
    protected override DoChildLinked(relation: string | null, related: RelatedObject | null): void {
        if (this.CopyOf){
            return;
        }

        if (relation === 'change' && related instanceof TicketChange){
            if (related === this.change){
                related.AddTicketsii(this);
            }
            else {
                related.DelTicketsii(this);
            }
            return;
        }

        // relate.by is the FK column (`invceac`), not the alias (`invoice`).
        if (relation === 'invceac' && related instanceof AccountInvoice){
            if (related === this.invoice){
                related.AddTicketsii(this);
            }
            else {
                related.DelTicketsii(this);
            }
        }
    }

    get IsValid(): boolean {
        return this.valid != null;
    }
}
